type LanguageCode = "en" | "fr" | "de" | "it" | "bg" | "es" | "pt" | "rm" | "sv" | "nl" | "pl" | "ru" | "uk" | "ro" | "el" | "cs" | "tr" | "sr" | "ko" | "ja";

const TEXTS = {
  en: {
    placeholders: {
      youtube: {
        leadText: "YouTube is disabled.",
        text: "YouTube uses tracers and may send personal data outside your country of residence.",
        enable: "Allow YouTube"
      },
      vimeo: {
        leadText: "Vimeo is disabled.",
        text: "Vimeo uses tracers and may send personal data outside your country of residence.",
        enable: "Allow Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps is disabled.",
        text: "Google Maps uses tracers and may send personal data outside your country of residence.",
        enable: "Allow Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap is disabled.",
        text: "OpenStreetMap uses tracers and may send personal data outside your country of residence.",
        enable: "Allow OpenStreetMap"
      },
    }
  },
  fr: {
    placeholders: {
      youtube: {
        leadText: "YouTube est désactivé.",
        text: "Youtube utilise des traceurs et peut envoyer des données personnelles en dehors de votre pays de résidence.",
        enable: "Autoriser YouTube"
      },
      vimeo: {
        leadText: "Vimeo est désactivé.",
        text: "Vimeo utilise des traceurs et peut envoyer des données personnelles en dehors de votre pays de résidence.",
        enable: "Autoriser Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps est désactivé.",
        text: "Google Maps utilise des traceurs et peut envoyer des données personnelles en dehors de votre pays de résidence.",
        enable: "Autoriser Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap est désactivé.",
        text: "OpenStreetMap utilise des traceurs et peut envoyer des données personnelles en dehors de votre pays de résidence.",
        enable: "Autoriser OpenStreetMap"
      },
    }
  },
  de: {
    placeholders: {
      youtube: {
        leadText: "YouTube ist deaktiviert.",
        text: "YouTube verwendet Tracker und kann persönliche Daten außerhalb des Landes Ihres Wohnsitzes senden.",
        enable: "Erlaube YouTube"
      },
      vimeo: {
        leadText: "Vimeo ist deaktiviert.",
        text: "Vimeo verwendet Tracker und kann persönliche Daten außerhalb des Landes Ihres Wohnsitzes senden.",
        enable: "Erlaube Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps ist deaktiviert.",
        text: "Google Maps verwendet Tracker und kann persönliche Daten außerhalb des Landes Ihres Wohnsitzes senden.",
        enable: "Erlaube Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap ist deaktiviert.",
        text: "OpenStreetMap verwendet Tracker und kann persönliche Daten außerhalb des Landes Ihres Wohnsitzes senden.",
        enable: "Erlaube OpenStreetMap"
      },
    }
  },
  it: {
    placeholders: {
      youtube: {
        leadText: "YouTube è disabilitato.",
        text: "YouTube utilizza tracciatori e può inviare dati personali al di fuori del paese di residenza dell'utente.",
        enable: "Consenti a YouTube"
      },
      vimeo: {
        leadText: "Vimeo è disabilitato.",
        text: "Vimeo utilizza tracciatori e può inviare dati personali al di fuori del paese di residenza dell'utente.",
        enable: "Consenti a Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps è disabilitato.",
        text: "Google Maps utilizza tracciatori e può inviare dati personali al di fuori del paese di residenza dell'utente.",
        enable: "Consenti a Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap è disabilitato.",
        text: "OpenStreetMap utilizza tracciatori e può inviare dati personali al di fuori del paese di residenza dell'utente.",
        enable: "Consenti a OpenStreetMap"
      },
    }
  },
  bg: {
    placeholders: {
      youtube: {
        leadText: "YouTube е деактивиран.",
        text: "YouTube използва проследяващи файлове и може да изпрати лични данни извън страната ви на пребиваване.",
        enable: "Упълномощаване на YouTube"
      },
      vimeo: {
        leadText: "Vimeo е деактивиран.",
        text: "Vimeo използва проследяващи файлове и може да изпрати лични данни извън страната ви на пребиваване.",
        enable: "Упълномощаване на Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps е деактивиран.",
        text: "Google Maps използва проследяващи файлове и може да изпрати лични данни извън страната ви на пребиваване.",
        enable: "Упълномощаване на Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap е деактивиран.",
        text: "OpenStreetMap използва проследяващи файлове и може да изпрати лични данни извън страната ви на пребиваване.",
        enable: "Упълномощаване на OpenStreetMap"
      }
    }
  },
  es: {
    placeholders: {
      youtube: {
        leadText: "YouTube está desactivado.",
        text: "YouTube utiliza rastreadores y puede enviar datos personales fuera de su país de residencia.",
        enable: "Autorizo YouTube"
      },
      vimeo: {
        leadText: "Vimeo está desactivado.",
        text: "Vimeo utiliza rastreadores y puede enviar datos personales fuera de su país de residencia.",
        enable: "Autorizo Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps está desactivado.",
        text: "Google Maps utiliza rastreadores y puede enviar datos personales fuera de su país de residencia.",
        enable: "Autorizo Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap está desactivado.",
        text: "OpenStreetMap utiliza rastreadores y puede enviar datos personales fuera de su país de residencia.",
        enable: "Autorizo OpenStreetMap"
      },
    }
  },
  pt: {
    placeholders: {
      youtube: {
        leadText: "YouTube está desativado.",
        text: "YouTube utiliza localizadores e pode enviar dados pessoais para fora do seu país de residência.",
        enable: "Autorizar YouTube"
      },
      vimeo: {
        leadText: "Vimeo está desativado.",
        text: "Vimeo utiliza localizadores e pode enviar dados pessoais para fora do seu país de residência.",
        enable: "Autorizar Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps está desativado.",
        text: "Google Maps utiliza localizadores e pode enviar dados pessoais para fora do seu país de residência.",
        enable: "Autorizar Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap está desativado.",
        text: "OpenStreetMap utiliza localizadores e pode enviar dados pessoais para fora do seu país de residência.",
        enable: "Autorizar OpenStreetMap"
      },
    }
  },
  rm: {
    placeholders: {
      youtube: {
        leadText: "YouTube è deactivà.",
        text: "YouTube dovra trackers e po trametter datas persunalas ordaifer voss pajais da domicil.",
        enable: "Permetter YouTube"
      },
      vimeo: {
        leadText: "Vimeo è deactivà.",
        text: "Vimeo dovra trackers e po trametter datas persunalas ordaifer voss pajais da domicil.",
        enable: "Permetter Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps è deactivà.",
        text: "Google Maps dovra trackers e po trametter datas persunalas ordaifer voss pajais da domicil.",
        enable: "Permetter Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap è deactivà.",
        text: "OpenStreetMap dovra trackers e po trametter datas persunalas ordaifer voss pajais da domicil.",
        enable: "Permetter OpenStreetMap"
      },
    }
  },
  sv: {
    placeholders: {
      youtube: {
        leadText: "YouTube är inaktiverat.",
        text: "YouTube använder spårare och kan skicka personuppgifter utanför ditt bosättningsland.",
        enable: "Tillåt YouTube"
      },
      vimeo: {
        leadText: "Vimeo är inaktiverat.",
        text: "Vimeo använder spårare och kan skicka personuppgifter utanför ditt bosättningsland.",
        enable: "Tillåt Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps är inaktiverat.",
        text: "Google Maps använder spårare och kan skicka personuppgifter utanför ditt bosättningsland.",
        enable: "Tillåt Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap är inaktiverat.",
        text: "OpenStreetMap använder spårare och kan skicka personuppgifter utanför ditt bosättningsland.",
        enable: "Tillåt OpenStreetMap"
      },
    }
  },
  nl: {
    placeholders: {
      youtube: {
        leadText: "YouTube is uitgeschakeld.",
        text: "YouTube gebruikt trackers en kan persoonlijke gegevens buiten uw land van verblijf verzenden.",
        enable: "YouTube toestaan"
      },
      vimeo: {
        leadText: "Vimeo is uitgeschakeld.",
        text: "Vimeo gebruikt trackers en kan persoonlijke gegevens buiten uw land van verblijf verzenden.",
        enable: "Vimeo toestaan"
      },
      googleMaps: {
        leadText: "Google Maps is uitgeschakeld.",
        text: "Google Maps gebruikt trackers en kan persoonlijke gegevens buiten uw land van verblijf verzenden.",
        enable: "Google Maps toestaan"
      },
      openStreetMap: {
        leadText: "OpenStreetMap is uitgeschakeld.",
        text: "OpenStreetMap gebruikt trackers en kan persoonlijke gegevens buiten uw land van verblijf verzenden.",
        enable: "OpenStreetMap toestaan"
      },
    }
  },
  pl: {
    placeholders: {
      youtube: {
        leadText: "YouTube jest wyłączony.",
        text: "YouTube używa trackerów i może wysyłać dane osobowe poza kraj zamieszkania.",
        enable: "Zezwól na YouTube"
      },
      vimeo: {
        leadText: "Vimeo jest wyłączony.",
        text: "Vimeo używa trackerów i może wysyłać dane osobowe poza kraj zamieszkania.",
        enable: "Zezwól na Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps jest wyłączony.",
        text: "Google Maps używa trackerów i może wysyłać dane osobowe poza kraj zamieszkania.",
        enable: "Zezwól na Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap jest wyłączony.",
        text: "OpenStreetMap używa trackerów i może wysyłać dane osobowe poza kraj zamieszkania.",
        enable: "Zezwól na OpenStreetMap"
      },
    }
  },
  ru: {
    placeholders: {
      youtube: {
        leadText: "YouTube отключен.",
        text: "YouTube использует трекеры и может отправлять личные данные за пределы вашей страны проживания.",
        enable: "Разрешить YouTube"
      },
      vimeo: {
        leadText: "Vimeo отключен.",
        text: "Vimeo использует трекеры и может отправлять личные данные за пределы вашей страны проживания.",
        enable: "Разрешить Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps отключен.",
        text: "Google Maps использует трекеры и может отправлять личные данные за пределы вашей страны проживания.",
        enable: "Разрешить Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap отключен.",
        text: "OpenStreetMap использует трекеры и может отправлять личные данные за пределы вашей страны проживания.",
        enable: "Разрешить OpenStreetMap"
      },
    }
  },
  uk: {
    placeholders: {
      youtube: {
        leadText: "YouTube вимкнено.",
        text: "YouTube використовує трекери та може надсилати особисті дані за межі вашої країни проживання.",
        enable: "Дозволити YouTube"
      },
      vimeo: {
        leadText: "Vimeo вимкнено.",
        text: "Vimeo використовує трекери та може надсилати особисті дані за межі вашої країни проживання.",
        enable: "Дозволити Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps вимкнено.",
        text: "Google Maps використовує трекери та може надсилати особисті дані за межі вашої країни проживання.",
        enable: "Дозволити Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap вимкнено.",
        text: "OpenStreetMap використовує трекери та може надсилати особисті дані за межі вашої країни проживання.",
        enable: "Дозволити OpenStreetMap"
      },
    }
  },
  ro: {
    placeholders: {
      youtube: {
        leadText: "YouTube este dezactivat.",
        text: "YouTube folosește trackere și poate trimite date personale în afara țării dvs. de reședință.",
        enable: "Permite YouTube"
      },
      vimeo: {
        leadText: "Vimeo este dezactivat.",
        text: "Vimeo folosește trackere și poate trimite date personale în afara țării dvs. de reședință.",
        enable: "Permite Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps este dezactivat.",
        text: "Google Maps folosește trackere și poate trimite date personale în afara țării dvs. de reședință.",
        enable: "Permite Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap este dezactivat.",
        text: "OpenStreetMap folosește trackere și poate trimite date personale în afara țării dvs. de reședință.",
        enable: "Permite OpenStreetMap"
      },
    }
  },
  el: {
    placeholders: {
      youtube: {
        leadText: "Το YouTube είναι απενεργοποιημένο.",
        text: "Το YouTube χρησιμοποιεί ιχνηλάτες και μπορεί να στείλει προσωπικά δεδομένα εκτός της χώρας διαμονής σας.",
        enable: "Επιτρέψτε το YouTube"
      },
      vimeo: {
        leadText: "Το Vimeo είναι απενεργοποιημένο.",
        text: "Το Vimeo χρησιμοποιεί ιχνηλάτες και μπορεί να στείλει προσωπικά δεδομένα εκτός της χώρας διαμονής σας.",
        enable: "Επιτρέψτε το Vimeo"
      },
      googleMaps: {
        leadText: "Το Google Maps είναι απενεργοποιημένο.",
        text: "Το Google Maps χρησιμοποιεί ιχνηλάτες και μπορεί να στείλει προσωπικά δεδομένα εκτός της χώρας διαμονής σας.",
        enable: "Επιτρέψτε το Google Maps"
      },
      openStreetMap: {
        leadText: "Το OpenStreetMap είναι απενεργοποιημένο.",
        text: "Το OpenStreetMap χρησιμοποιεί ιχνηλάτες και μπορεί να στείλει προσωπικά δεδομένα εκτός της χώρας διαμονής σας.",
        enable: "Επιτρέψτε το OpenStreetMap"
      },
    }
  },
  cs: {
    placeholders: {
      youtube: {
        leadText: "YouTube je deaktivován.",
        text: "YouTube používá sledovače a může odesílat osobní údaje mimo vaši zemi pobytu.",
        enable: "Povolit YouTube"
      },
      vimeo: {
        leadText: "Vimeo je deaktivován.",
        text: "Vimeo používá sledovače a může odesílat osobní údaje mimo vaši zemi pobytu.",
        enable: "Povolit Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps je deaktivován.",
        text: "Google Maps používá sledovače a může odesílat osobní údaje mimo vaši zemi pobytu.",
        enable: "Povolit Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap je deaktivován.",
        text: "OpenStreetMap používá sledovače a může odesílat osobní údaje mimo vaši zemi pobytu.",
        enable: "Povolit OpenStreetMap"
      },
    }
  },
  tr: {
    placeholders: {
      youtube: {
        leadText: "YouTube devre dışı.",
        text: "YouTube izleyiciler kullanır ve kişisel verileri ikamet ettiğiniz ülkenin dışına gönderebilir.",
        enable: "YouTube'a izin ver"
      },
      vimeo: {
        leadText: "Vimeo devre dışı.",
        text: "Vimeo izleyiciler kullanır ve kişisel verileri ikamet ettiğiniz ülkenin dışına gönderebilir.",
        enable: "Vimeo'ya izin ver"
      },
      googleMaps: {
        leadText: "Google Maps devre dışı.",
        text: "Google Maps izleyiciler kullanır ve kişisel verileri ikamet ettiğiniz ülkenin dışına gönderebilir.",
        enable: "Google Maps'e izin ver"
      },
      openStreetMap: {
        leadText: "OpenStreetMap devre dışı.",
        text: "OpenStreetMap izleyiciler kullanır ve kişisel verileri ikamet ettiğiniz ülkenin dışına gönderebilir.",
        enable: "OpenStreetMap'e izin ver"
      },
    }
  },
  sr: {
    placeholders: {
      youtube: {
        leadText: "YouTube је деактивиран.",
        text: "YouTube користи пратиоце и може слати личне податке ван ваше земље пребивалишта.",
        enable: "Дозволи YouTube"
      },
      vimeo: {
        leadText: "Vimeo је деактивиран.",
        text: "Vimeo користи пратиоце и може слати личне податке ван ваше земље пребивалишта.",
        enable: "Дозволи Vimeo"
      },
      googleMaps: {
        leadText: "Google Maps је деактивиран.",
        text: "Google Maps користи пратиоце и може слати личне податке ван ваше земље пребивалишта.",
        enable: "Дозволи Google Maps"
      },
      openStreetMap: {
        leadText: "OpenStreetMap је деактивиран.",
        text: "OpenStreetMap користи пратиоце и може слати личне податке ван ваше земље пребивалишта.",
        enable: "Дозволи OpenStreetMap"
      },
    }
  },
  ko: {
    placeholders: {
      youtube: {
        leadText: "YouTube가 비활성화되었습니다.",
        text: "YouTube는 추적기를 사용하며 귀하의 거주 국가 외부로 개인 데이터를 전송할 수 있습니다.",
        enable: "YouTube 허용"
      },
      vimeo: {
        leadText: "Vimeo가 비활성화되었습니다.",
        text: "Vimeo는 추적기를 사용하며 귀하의 거주 국가 외부로 개인 데이터를 전송할 수 있습니다.",
        enable: "Vimeo 허용"
      },
      googleMaps: {
        leadText: "Google Maps가 비활성화되었습니다.",
        text: "Google Maps는 추적기를 사용하며 귀하의 거주 국가 외부로 개인 데이터를 전송할 수 있습니다.",
        enable: "Google Maps 허용"
      },
      openStreetMap: {
        leadText: "OpenStreetMap이 비활성화되었습니다.",
        text: "OpenStreetMap은 추적기를 사용하며 귀하의 거주 국가 외부로 개인 데이터를 전송할 수 있습니다.",
        enable: "OpenStreetMap 허용"
      },
    }
  },
  ja: {
    placeholders: {
      youtube: {
        leadText: "YouTubeは無効化されています。",
        text: "YouTubeはトラッカーを使用し、お客様の居住国外に個人データを送信する可能性があります。",
        enable: "YouTubeを許可"
      },
      vimeo: {
        leadText: "Vimeoは無効化されています。",
        text: "Vimeoはトラッカーを使用し、お客様の居住国外に個人データを送信する可能性があります。",
        enable: "Vimeoを許可"
      },
      googleMaps: {
        leadText: "Google Mapsは無効化されています。",
        text: "Google Mapsはトラッカーを使用し、お客様の居住国外に個人データを送信する可能性があります。",
        enable: "Google Mapsを許可"
      },
      openStreetMap: {
        leadText: "OpenStreetMapは無効化されています。",
        text: "OpenStreetMapはトラッカーを使用し、お客様の居住国外に個人データを送信する可能性があります。",
        enable: "OpenStreetMapを許可"
      },
    }
  }
}

function translations(code: LanguageCode): any {
  return TEXTS[code];
}

export { LanguageCode, translations };
